/**
 * @generated SignedSource<<c12579ef85be4cf651b5d317df8085e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type settingsAlertsPageLoaderQuery$variables = Record<PropertyKey, never>;
export type settingsAlertsPageLoaderQuery$data = {
  readonly alertPreferences: {
    readonly costAlertEnabled: boolean;
    readonly costThreshold: number;
    readonly errorAlertEnabled: boolean;
    readonly piiEnabled: boolean;
    readonly systemHealthAlertEnabled: boolean;
  } | null;
  readonly piiConfig: {
    readonly excludedEntities: ReadonlyArray<string>;
  } | null;
  readonly smtpConfig: {
    readonly host: string;
    readonly port: number;
    readonly recipientAddress: string;
    readonly senderAddress: string;
    readonly username: string;
  } | null;
};
export type settingsAlertsPageLoaderQuery = {
  response: settingsAlertsPageLoaderQuery$data;
  variables: settingsAlertsPageLoaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SMTPConfig",
    "kind": "LinkedField",
    "name": "smtpConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "host",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "port",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "senderAddress",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recipientAddress",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "AlertPreferences",
    "kind": "LinkedField",
    "name": "alertPreferences",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "piiEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "costAlertEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "costThreshold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorAlertEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "systemHealthAlertEnabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PIIConfig",
    "kind": "LinkedField",
    "name": "piiConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "excludedEntities",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "settingsAlertsPageLoaderQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "settingsAlertsPageLoaderQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2420bf704cfa983d44f3eb20daeca49c",
    "id": null,
    "metadata": {},
    "name": "settingsAlertsPageLoaderQuery",
    "operationKind": "query",
    "text": "query settingsAlertsPageLoaderQuery {\n  smtpConfig {\n    host\n    port\n    username\n    senderAddress\n    recipientAddress\n  }\n  alertPreferences {\n    piiEnabled\n    costAlertEnabled\n    costThreshold\n    errorAlertEnabled\n    systemHealthAlertEnabled\n  }\n  piiConfig {\n    excludedEntities\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ebdd79fbfece8154658847d7c5535b5";

export default node;
